module.exports = __webpack_public_path__ + "img/card1.970a15ca.png";